import { BaseModel } from 'paliari-js-utils'
import DocCalculoGrauInfracao from './DocCalculoGrauInfracao'
import DocCalculoRegra from './DocCalculoRegra'

const attributes = {
  tipo_valor_parametro: '',
  buscar_area_do_cadastro: true,
  regras: (arr = []) => arr.map(item => new DocCalculoRegra(item)),
  grau_de_infracoes: (arr = []) =>
    arr.map(item => new DocCalculoGrauInfracao(item)),
}

class DocCalculo extends BaseModel {
  constructor(obj) {
    super(attributes, obj)
  }
}

export default DocCalculo
